import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { currentRegion } from "../config/regions";
import { FEATURE_PRIVACY_POLICY } from "../config/featureFlags";
import { LEGAL_PRIVACY_URL, LEGAL_TERMS_URL } from "../config/legalUrls";

/**
 * US-only legal notice with links to marketing-site Privacy Policy and Terms of Use.
 */
const LegalTermsNotice = ({ variant = "signin" }) => {
  const { t } = useLanguage();

  if (!FEATURE_PRIVACY_POLICY || currentRegion !== "us") {
    return null;
  }

  const noticeKey = variant === "signup" ? "legal.termsNoticeSignup" : "legal.termsNoticeSignin";

  return (
    <p className="text-center text-xs text-muted-foreground pt-2" data-testid="legal-terms-notice">
      {t(noticeKey)}{" "}
      <a
        href={LEGAL_PRIVACY_URL}
        className="text-primary hover:underline"
        data-testid="privacy-policy-link"
        rel="noopener noreferrer"
      >
        {t("legal.privacyPolicy")}
      </a>{" "}
      {t("legal.and")}{" "}
      <a
        href={LEGAL_TERMS_URL}
        className="text-primary hover:underline"
        data-testid="terms-of-use-link"
        rel="noopener noreferrer"
      >
        {t("legal.termsOfUse")}
      </a>
    </p>
  );
};

export default LegalTermsNotice;
